document.addEventListener('DOMContentLoaded', () => {

  const drawer = document.querySelector('[data-menu-mobile-drawer]');

  // Before moving panels, store references between triggers and their panels
  if (drawer) {
    let panelId = 0;

    // Link open-level triggers to their submenu panels
    const openLevelElements = drawer.querySelectorAll('[data-menu-mobile-open-level]');
    openLevelElements.forEach(el => {
      const submenu = el.querySelector('[data-menu-mobile-submenu-list]');
      if (submenu) {
        const id = 'mobile-submenu-' + panelId++;
        submenu.setAttribute('data-panel-id', id);
        el.setAttribute('data-target-panel', id);
      }
    });

    // Link back buttons to their panels
    const backButtons = drawer.querySelectorAll('[data-menu-mobile-back-button]');
    backButtons.forEach(btn => {
      const panel = btn.closest('[data-menu-mobile-submenu-list]');
      if (panel && panel.dataset.panelId) {
        btn.setAttribute('data-target-panel', panel.dataset.panelId);
      }
    });

    // Link third-level back buttons to their panels
    const thirdBackButtons = drawer.querySelectorAll('[data-menu-mobile-back-third-level]');
    thirdBackButtons.forEach(btn => {
      const panel = btn.closest('[data-menu-mobile-third-level-list]');
      if (panel) {
        const id = 'mobile-third-' + panelId++;
        panel.setAttribute('data-panel-id', id);
        btn.setAttribute('data-target-panel', id);
      }
    });

    // Move sub-panels to be direct children of the drawer
    const submenus = drawer.querySelectorAll('[data-menu-mobile-submenu-list]');
    submenus.forEach(submenu => drawer.appendChild(submenu));
    const thirdLevels = drawer.querySelectorAll('[data-menu-mobile-third-level-list]');
    thirdLevels.forEach(thirdLevel => drawer.appendChild(thirdLevel));
  }

  // Add event listener to mobile filter buttons
  const mobileFilterButtons = document.querySelectorAll('[data-mobile-main-filter-button]');

  mobileFilterButtons.forEach(mobileFilterBtn => {
    mobileFilterBtn.addEventListener('click', () => {
      const menuToFilter = mobileFilterBtn.dataset.mobileMainFilterButton;

      mobileFilterButtons.forEach(filterBtn => filterBtn.classList.remove('active'));
      mobileFilterBtn.classList.add('active');

      const menuGroups = document.querySelectorAll('[data-mobile-menu-group]');
      menuGroups.forEach(group => group.classList.remove('active'));

      const targetGroup = document.querySelector(`[data-mobile-menu-group="${menuToFilter}"]`);
      if (targetGroup) {
        targetGroup.classList.add('active');
      }
    });
  });

  const menuMobileIcon = document.querySelector('[data-menu-mobile-icon]');
  const menuMobileDrawer = document.querySelector('[data-menu-mobile-drawer]');
  const menuMobileDrawerClose = document.querySelector('[data-menu-mobile-close]');
  const menuMobileDrawerMask = document.querySelector('[data-menu-mobile-drawer-mask]');

  menuMobileIcon && menuMobileIcon.addEventListener('click', (e) => {
    e.preventDefault();
    document.body.classList.add('lock')
    menuMobileDrawer.classList.toggle('active');
    menuMobileDrawerMask.classList.toggle('active');
    const isOpen = menuMobileDrawer.classList.contains('active');
    menuMobileIcon.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    // Find first mobile filter button and simulate click
    const firstMobileFilterBtn = document.querySelector('.mobile-main-filter-btn');
    if (firstMobileFilterBtn) {
      firstMobileFilterBtn.click();
    }
  })

  // Function to reset mobile menu internal state
  const resetMobileMenuInternalState = () => {
    // Reset all second level submenus
    const allSubmenuLists = document.querySelectorAll('[data-menu-mobile-submenu-list]');
    allSubmenuLists.forEach(submenu => submenu.classList.remove('active'));

    // Reset all third level submenus
    const allThirdLevelLists = document.querySelectorAll('[data-menu-mobile-third-level-list]');
    allThirdLevelLists.forEach(thirdLevel => thirdLevel.classList.remove('active'));

    // Reset filter buttons to first one
    const firstMobileFilterBtn = document.querySelector('.mobile-main-filter-btn');
    if (firstMobileFilterBtn) {
      mobileFilterButtons.forEach(filterBtn => filterBtn.classList.remove('active'));
      firstMobileFilterBtn.classList.add('active');

      const menuGroups = document.querySelectorAll('[data-mobile-menu-group]');
      menuGroups.forEach(group => group.classList.remove('active'));

      const menuToFilter = firstMobileFilterBtn.dataset.mobileMainFilterButton;
      const targetGroup = document.querySelector(`[data-mobile-menu-group="${menuToFilter}"]`);
      if (targetGroup) {
        targetGroup.classList.add('active');
      }
    }
  };

  menuMobileDrawerClose && menuMobileDrawerClose.addEventListener('click', (e) => {
    e.preventDefault();
    menuMobileDrawer.classList.remove('active');
    menuMobileDrawerMask.classList.remove('active');
    document.body.classList.remove('lock');
    if (menuMobileIcon) menuMobileIcon.setAttribute('aria-expanded', 'false');
    resetMobileMenuInternalState();
  })

  menuMobileDrawerMask && menuMobileDrawerMask.addEventListener('click', (e) => {
    e.preventDefault();
    menuMobileDrawer.classList.remove('active');
    menuMobileDrawerMask.classList.remove('active');
    document.body.classList.remove('lock');
    if (menuMobileIcon) menuMobileIcon.setAttribute('aria-expanded', 'false');
    resetMobileMenuInternalState();
  })

  // Open second level - find panel by data-target-panel
  const mobileOpenLevelElements = document.querySelectorAll('[data-menu-mobile-open-level]');
  mobileOpenLevelElements.forEach(openLevelEl => {
    openLevelEl && openLevelEl.addEventListener('click', (e) => {
      const backButton = openLevelEl.querySelector('[data-menu-mobile-back-button]')
      if (backButton && (e.target === backButton || backButton.contains(e.target))) return

      e.preventDefault();
      const panelId = openLevelEl.dataset.targetPanel;
      if (panelId) {
        const panel = document.querySelector(`[data-panel-id="${panelId}"]`);
        panel && panel.classList.add('active');
      }
    })
  })

  // Child links navigation
  const mobileChildLinks = document.querySelectorAll('[data-mega-menu-mobile-child-link]')
  mobileChildLinks.forEach(mobileLink => {
    if (!mobileLink) return
    mobileLink.addEventListener('click', (e) => {
      const href = mobileLink.getAttribute('href') || ''
      const isAnchor = href.trim().startsWith('#')
      if (!isAnchor) {
        e.preventDefault();
        menuMobileDrawer && menuMobileDrawer.classList.remove('active');
        menuMobileDrawerMask && menuMobileDrawerMask.classList.remove('active');
        document.body.classList.remove('lock');
        resetMobileMenuInternalState();
        window.location.href = href
      }
    })
  })

  // Back button for second level - find panel by data-target-panel
  const mobileBackLevelButton = document.querySelectorAll('[data-menu-mobile-back-button]');
  mobileBackLevelButton.forEach(backLevelBtn => {
    backLevelBtn && backLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const panelId = backLevelBtn.dataset.targetPanel;
      if (panelId) {
        const panel = document.querySelector(`[data-panel-id="${panelId}"]`);
        panel && panel.classList.remove('active');
      }
    })
  })

  // Open third level
  const mobileOpenThirdLevelElements = document.querySelectorAll('[data-menu-mobile-open-third-level]');
  mobileOpenThirdLevelElements.forEach(openThirdLevelEl => {
    openThirdLevelEl && openThirdLevelEl.addEventListener('click', (e) => {
      e.preventDefault();
      const childId = openThirdLevelEl.dataset.childId;
      if (childId) {
        // Hide all third level lists
        const allThirdLevelLists = document.querySelectorAll('[data-menu-mobile-third-level-list]');
        allThirdLevelLists.forEach(list => list.classList.remove('active'));

        // Show the corresponding third level list
        const targetThirdLevel = document.querySelector(`[data-menu-mobile-third-level-list][data-child="${childId}"]`);
        if (targetThirdLevel) {
          targetThirdLevel.classList.add('active');
        }
      }
    })
  })

  // Back button for third level
  const mobileBackThirdLevelButtons = document.querySelectorAll('[data-menu-mobile-back-third-level]');
  mobileBackThirdLevelButtons.forEach(backThirdLevelBtn => {
    backThirdLevelBtn && backThirdLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const panelId = backThirdLevelBtn.dataset.targetPanel;
      if (panelId) {
        const panel = document.querySelector(`[data-panel-id="${panelId}"]`);
        panel && panel.classList.remove('active');
      }
    })
  })

  // Handle third level sub-links
  const mobileSubLinks = document.querySelectorAll('[data-mega-menu-mobile-sub-link]')
  mobileSubLinks.forEach(mobileSubLink => {
    if (!mobileSubLink) return
    mobileSubLink.addEventListener('click', (e) => {
      const href = mobileSubLink.getAttribute('href') || ''
      const isAnchor = href.trim().startsWith('#')
      if (!isAnchor) {
        e.preventDefault();
        menuMobileDrawer && menuMobileDrawer.classList.remove('active');
        menuMobileDrawerMask && menuMobileDrawerMask.classList.remove('active');
        document.body.classList.remove('lock');
        resetMobileMenuInternalState();
        window.location.href = href
      }
    })
  })

  // Handle third level image links
  const mobileSubImageLinks = document.querySelectorAll('.mega-menu-mobile-sub-link-image')
  mobileSubImageLinks.forEach(mobileSubImageLink => {
    if (!mobileSubImageLink) return
    mobileSubImageLink.addEventListener('click', (e) => {
      const href = mobileSubImageLink.getAttribute('href') || ''
      const isAnchor = href.trim().startsWith('#')
      if (!isAnchor) {
        e.preventDefault();
        menuMobileDrawer && menuMobileDrawer.classList.remove('active');
        menuMobileDrawerMask && menuMobileDrawerMask.classList.remove('active');
        document.body.classList.remove('lock');
        resetMobileMenuInternalState();
        window.location.href = href
      }
    })
  })

});
